import normalize from "json-api-normalize";
import Attributes from "../../models/Attributes.js";
import Vue from 'vue';

export const OrganizationsApi = {
  getOrganization() {
    return Vue.http.get("/api/customers/organizations").then(fulfilled => {
      return normalize(fulfilled.body).get(Attributes.organizationAttributes);
    })
  },

  getIndustries() {
    return Vue.http.get("/api/customers/organizations/industries").then(fulfilled => {
      return fulfilled.body
    })
  },

  saveOrganization(params) {
    return Vue.http.patch("/api/customers/organizations", {
      organization: params
    })
  },

  getOnboarding() {
    return Vue.http.get("/api/customers/onboardings").then(response => {
      return response.data;
    });
  },

  updateOnboarding(params) {
    return Vue.http.patch("/api/customers/onboardings", {
      customer_onboarding: params
    })
  },

  async updateOrganization(params) {
    const response = await Vue.http.patch("/api/customers/organizations", {organization: params})
    return normalize(response.body).get(Attributes.organizationAttributes);
  },

  getHoldingCompanies() {
    return Vue.http.get("/api/customers/holding_companies").then(response => {
      return normalize(response.body).get(Attributes.holdingCompanyAttributes);
    })
  },

  async getAdminCandidates(query) {
    const response = await Vue.http.post("/api/customers/organizations/admin_candidates", {query});
    return normalize(response.body).get(Attributes.userAttributes);
  }
}